import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Route } from '@app/core/enums/route.enum';
import { WorkComponent } from './pages/work/work.component';

const workRoutes: Routes = [
  {
    path: '',
    component: WorkComponent,
    data: { pageTitle: 'MyWork' },
    title: 'My Work'
  },
  {
    path: Route.TimeRegistration,
    loadChildren: () => import('@app/time-registration/time-registration.routes').then((m) => m.timeRegistrationRoutes),
  },
  {
    path: Route.Expenses,
    loadChildren: () => import('@app/expenses/expenses.routes').then((m) => m.expensesRoutes),
  },
  {
    path: Route.Requests,
    loadChildren: () => import('@app/holiday/holiday.routes').then((m) => m.holidayRoutes),
  },
  {
    path: Route.Balance,
    loadChildren: () => import('@app/balance/routes/balance.routes').then((m) => m.balanceRoutes),
  },
];

@NgModule({
  imports: [RouterModule.forChild(workRoutes)],
  exports: [RouterModule],
})
export class WorkRoutingModule {}
